import React from 'react';
import { View } from 'react-native';
import { getTranslatedProperty } from '../../../utils/localization.utils';
import { useThemedStyleFunction } from '../../theme-provider';
import { ThemedText } from '../../themed-text';
import { listContentStyle } from './list-content.style';


interface AoiListContentProps {
    name: string,
    category: any
}

const AoiListContent = (props: AoiListContentProps) => {
    const {name, category} = props;
    const categoryName = getTranslatedProperty('name', category);
    const style = useThemedStyleFunction(listContentStyle);

    return (
        <View style={style.container}>
            <View style={style.content}>
                <View style={[style.flexRow, style.row]}>
                    <ThemedText type="bold" style={style.title}>{ name }</ThemedText>
                </View>
                <View style={[style.flexRow, style.row]}>
                    <ThemedText type="standard" style={style.subtitle}>{ categoryName }</ThemedText>
                </View>
            </View>
        </View>
    );
};

export { AoiListContent };